module.exports = __webpack_public_path__ + "static/media/vue.87ef18a6.svg";